<div class="jam_body">
    <div class="container">
    <div class="text-center">
    <h1>Thank You.</h1>
    <h2>Order Confirmed.</h2>
</div>
</div>
</div>
